/* eslint-disable */
export default {
  rateExceeded:
    '요청 제한이 초과되었습니다. {ttl}초 후에 앱이 다시 시작됩니다.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
